module.exports = __webpack_public_path__ + "media/images/country_flags/al-d3369d3ccda32354943a3c0c236a13bb.png";